// extracted by mini-css-extract-plugin
export default {"heading":"Guides_heading__6HfcL","subheading":"Guides_subheading__luIuU","tabsContainer":"Guides_tabsContainer__mAJgr"};